import { render } from "./Login.vue?vue&type=template&id=156a05ae"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__